import React from "react";
/* eslint-disable */
import { Box, TableBody, TableCell, TableHead, TableRow, Table } from '@material-ui/core';
import moment from 'moment';
export default class ComponentToPrint extends React.Component {
    state = {
        page: 0,
        rowsPerPage: 5
    };

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 });
    };

    render() {
        const vehicleUtilizationData = this.props.vehicleUtilizationData;
        const total = this.props.total;

        return (
            <div style={{ padding: '10px' }}>
                <h3><center><u>FDC Vehicle Utilization Report</u></center></h3>
                <div>&nbsp;</div>
                <div>&nbsp;</div>
                <Box minWidth={1050}>
                    <Table aria-label="caption table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="left" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Date</TableCell>
                                <TableCell align="left" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>FCC</TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Volume&nbsp;</TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Number&nbsp;of&nbsp;Lorries</TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Vehicle&nbsp;Code</TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Lorry&nbsp;Size&nbsp;</TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Lorry&nbsp;Capacity&nbsp;</TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Vehicle&nbsp;Utilization&nbsp;%</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(() => {
                                const groupedMap = new Map();
                                vehicleUtilizationData.forEach((item) => {
                                    const dateStr = moment(item.date).format('YYYY-MM-DD')
                                    const groupKey = `${dateStr}|${item.vehicleCode}`;
                                    if (!groupedMap.has(groupKey)) {
                                        groupedMap.set(groupKey, {
                                            date: dateStr,
                                            numOfLorry: item.numOfLorry,
                                            vehicleCode: item.vehicleCode,
                                            size: item.size,
                                            capacity: item.capacity,
                                            rows: [],
                                            totalVolume: 0
                                        });
                                    }
                                    const group = groupedMap.get(groupKey);
                                    group.rows.push(item);
                                    group.totalVolume += item.volume;
                                });

                                const groupedData = Array.from(groupedMap.values());

                                return groupedData.map((group, groupIndex) => {
                                    const utilization = group.capacity == 0 ? '-' : parseFloat((group.capacity / group.totalVolume) * 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

                                    return (
                                        <React.Fragment key={groupIndex}>
                                            {group.rows.map((row, rowIndex) => (
                                                <TableRow key={rowIndex}>
                                                    <TableCell style={{ verticalAlign: 'middle', textAlign: 'right', justifyContent: 'center' }}>
                                                        {group.date}
                                                    </TableCell>
                                                    <TableCell style={{ verticalAlign: 'middle', textAlign: 'left', justifyContent: 'center' }}>
                                                        {row.factoryName}
                                                    </TableCell>
                                                    <TableCell style={{ verticalAlign: 'middle', textAlign: 'right', justifyContent: 'center' }}>
                                                        {row.volume == 0 ? '-' : parseFloat(row.volume).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </TableCell>
                                                    {rowIndex === 0 && (
                                                        <TableCell
                                                            style={{ verticalAlign: 'middle', textAlign: 'center', fontWeight: 'bold' }}
                                                            rowSpan={group.rows.length}
                                                        >
                                                            {group.numOfLorry}
                                                        </TableCell>
                                                    )}
                                                    {rowIndex === 0 && (
                                                        <TableCell
                                                            style={{ verticalAlign: 'middle', textAlign: 'center', fontWeight: 'bold' }}
                                                            rowSpan={group.rows.length}
                                                        >
                                                            {group.vehicleCode}
                                                        </TableCell>
                                                    )}
                                                    {rowIndex === 0 && (
                                                        <TableCell
                                                            style={{ verticalAlign: 'middle', textAlign: 'center', fontWeight: 'bold' }}
                                                            rowSpan={group.rows.length}
                                                        >
                                                            {group.size == 0 ? '-' : parseFloat(group.size).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </TableCell>
                                                    )}
                                                    {rowIndex === 0 && (
                                                        <TableCell
                                                            style={{ verticalAlign: 'middle', textAlign: 'center', fontWeight: 'bold' }}
                                                            rowSpan={group.rows.length}
                                                        >
                                                            {group.capacity == 0 ? '-' : parseFloat(group.capacity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </TableCell>
                                                    )}
                                                    {rowIndex === 0 && (
                                                        <TableCell
                                                            style={{ verticalAlign: 'middle', textAlign: 'center', fontWeight: 'bold' }}
                                                            rowSpan={group.rows.length}
                                                        >
                                                            {utilization}
                                                        </TableCell>
                                                    )}
                                                </TableRow>
                                            ))}
                                        </React.Fragment>
                                    );
                                });
                            })()}
                            <TableRow>
                                <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'left' }} colSpan={2}>
                                    Total
                                </TableCell>
                                <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                    {isNaN(total.totalVolume) || total.totalVolume === 0 ? '-' : parseFloat(total.totalVolume).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </TableCell>
                                <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'center', justifyContent: 'center' }}>
                                    {isNaN(total.totalNumOfLorry) || total.totalNumOfLorry === 0 ? '-' : (total.totalNumOfLorry)}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Box>
            </div>
        );
    }
}
